( function ($) {
    $(document).ready(function () {
        collapsibleContent();
        event_aside();
        doGallery();
        addFancy();
        contentWithImage();
    });

    function collapsibleContent() {
        var buttons = $('.main_content .collapsibleContent_btn'),
            mClass = 'open',
            mClass2 = 'content_is_visible';
        buttons.each(function () {
           var button = $(this);
           button.click(function () {
                var btn = $(this);
                var parent = btn.closest('.container');
                var wrap = parent.find('.collapsibleContent');
                if (!btn.hasClass(mClass)) {
                    var height = wrap.find('.the_content').outerHeight(true);
                    wrap.stop().animate({
                        'height': height
                    });
                    btn.addClass(mClass);
                    btn.html(read_less);
                    $(parent).addClass(mClass2);
                } else {
                    wrap.stop().animate({
                        'height': 0
                    });
                    btn.html(read_more);
                    btn.removeClass(mClass);
                    $(parent).removeClass(mClass2);
                }
            });
        });

    }

    /*
        TODO move to shared / add parameters
     */
    function addFancy() {
        $('.main_content .fancy').fancybox();
    }

    function event_aside() {
        var aside = $('.section.main_content .aside.gallery,.section.main_content .aside.single_image');
        if ($(document.body).hasClass('single-event') || $(document.body).hasClass('single-news') && aside.length > 0) {
            aside.insertBefore('.section.main_content .main_the_content');
            aside.addClass('before_body');
            $('<div class="aside_gallery_pager pager"></div>').appendTo(aside.eq(0));
        }
    }


    function doGallery() {
        var aside = $('.section.main_content .aside.gallery,.section.main_content .aside.single_image');
        var isGalleryBeforeBody = $(document.body).hasClass('single-event') || $(document.body).hasClass('single-news') && aside.length > 0;

        var wraps = $('.main_content .aside .gallery_container');
        if (wraps.length > 0) {
            //slideshow setup
            wraps.each(function () {
                var wrap = $(this);
                wrap.on("init", function () {
                    lazyLoadInstance.update();
                });
                wrap.slick({
                    rows: 0,
                    fade: true,
                    autoplay: false,
                    arrows: true,
                    dots: isGalleryBeforeBody,
                    appendDots: isGalleryBeforeBody ? '.aside_gallery_pager' : undefined,
                    nextArrow: wrap.parent().find('.next'),
                    prevArrow: wrap.parent().find('.prev'),
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rtl: $('html').attr('dir') == 'rtl'
                });
            })
        }
    }

    function contentWithImage() {
        var image =  $('.main_content .aside.single_image').not('.before_body');
        if (image.length > 0 && !is_mobile) {
            image.css({
                'min-height': image.width()
            })
        }
    }

})(jQuery);

